<script setup lang="ts">
    import { typographyClasses, typographyStyle } from './classes';
    import type { TypographyStyleProps } from './classes';

    type Props = TypographyStyleProps & {
        as?: 'div' | 'span' | 'p';
    };

    const props = withDefaults(defineProps<Props>(), {
        as: 'div',
    });

    const styleProps = computed(() => ({
        size: props.size,
        weight: props.weight,
        color: props.color,
        decoration: props.decoration,
        transform: props.transform,
        italic: props.italic,
        tabularNums: props.tabularNums,
        truncate: props.truncate,
        lineClamp: props.lineClamp,
    }));
</script>

<template>
    <component
        :is="as"
        data-slot="text"
        :class="['ui-text', typographyClasses(styleProps)]"
        :style="typographyStyle(styleProps)"
    >
        <slot />
    </component>
</template>

<style scoped src="./typography.css"></style>
